<script>
import NavigationLogo from '@/components/navigation/NavigationLogo.vue'
import { mapGetters } from 'vuex'
import GlobalSearchInput from '@/components/navigation/GlobalSearchInput.vue'

export default {
  components: { GlobalSearchInput, NavigationLogo },
  props: {
    showLogo: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    searchString: '',
    displaySearch: false,
    isExpandingOnHover: false
  }),
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'greeting',
      'initials',
      'username',
      'urls'
    ]),
    navigationItems() {
      const urls = this.$store.getters.urls || {};
      return [
        {
          id: 'navbar-link-profile',
          to: { name: 'profile' },
          external: false,
          restriction: () => true,
          icon: 'mdi-account-cog-outline',
          color: 'primary',
          text: this.$t('navigation.header.profile')
        },
        {
          id: 'navbar-link-about',
          to:
            urls.footerAboutUrl && urls.footerAboutUrl !== ''
              ? urls.footerAboutUrl
              : 'https://fp-dbs.com',
          external: true,
          restriction: () => true,
          icon: 'mdi-home-city-outline',
          color: 'primary',
          text: this.$t('navigation.header.about')
        },
        {
          id: 'navbar-link-contact',
          to:
            urls.footerContactUrl && urls.footerContactUrl !== ''
              ? urls.footerContactUrl
              : 'mailto:info@fp-dbs.com',
          external: true,
          restriction: () => true,
          icon: 'mdi-message-outline',
          color: 'primary',
          text: this.$t('navigation.header.contact')
        },
        {
          id: 'navbar-link-logout',
          to: { name: 'logout' },
          external: false,
          restriction: () => true,
          icon: 'mdi-power',
          color: 'error',
          text: this.$t('navigation.header.logout')
        }
      ]
    },
    dynamicWhitelabelURL() {
      if (
        this?.urls?.faqUrl &&
        this?.urls?.faqUrl?.includes('http') &&
        this?.urls?.faqUrl?.includes('https')
      ) {
        return this.urls.faqUrl
      }
      return `https://${this?.urls?.faqUrl}`
    },
    hasBriefbutlerPermissions() {
      return (
        this.isAuthenticated &&
        this.$store.getters.selectedOrganization &&
        this.$permissions?.hasBriefbutler
      )
    }
  }
}
</script>

<template>
  <v-app-bar
    id="navbar"
    :color="$vuetify.theme.themes.light.navbarBackground"
    app
    fixed
    style="height:64px">
    <v-app-bar-nav-icon v-if="showLogo">
      <NavigationLogo />
    </v-app-bar-nav-icon>

    <v-spacer></v-spacer>

    <!--    BRIEFBUTLER INFO-->
    <span
      v-if="hasBriefbutlerPermissions"
      class="pe-3"
      :style="`color: ${$vuetify.theme.themes.light.navbarLink}`">
      {{ $t('navigation.briefbutler.info.text') }}
    </span>

    <!--    SEARCH INPUT-->
    <GlobalSearchInput />

    <!--    FAQ-->
    <v-btn
      v-if="$store.getters.urls && $store.getters.urls.faqUrl"
      id="faq-url-a-href"
      target="_blank"
      icon
      color="navbarLink"
      :href="dynamicWhitelabelURL">
      <v-icon>mdi-help-circle</v-icon>
    </v-btn>

    <router-link v-else id="faq-link-router-link" to="/faq" icon>
      <v-btn icon color="navbarLink">
        <v-icon>mdi-help-circle</v-icon>
      </v-btn>
    </router-link>

    <router-link v-if="!isAuthenticated" to="/signin" icon>
      <v-btn icon color="navbarLink">
        <v-icon>mdi-login</v-icon>
      </v-btn>
    </router-link>

    <v-menu v-if="isAuthenticated" offset-y>
      <template #activator="{ on, attrs }">
        <v-btn icon color="navbarLink" v-bind="attrs" v-on="on">
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item>
          <v-list-item-avatar color="secondary" class="white--text">
            {{ initials }}
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title :title="greeting">
              {{greeting}}
            </v-list-item-title>
            <v-list-item-subtitle :title="username">
              {{username}}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <template v-for="(item, index) in navigationItems">
          <a
            v-if="item.external"
            :id="item.id"
            :key="index"
            :href="item.to"
            target="_blank"
            rel="noopener"
            class="v-list-item v-list-item--link">
            <v-list-item-icon>
              <v-icon :color="item.color">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              <span class="text--primary">
              {{item.text}}
            </span></v-list-item-title>
          </a>

          <v-list-item v-else :id="item.id" :key="index" :to="item.to" link>
            <v-list-item-icon>
              <v-icon :color="item.color">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              <span class="text--primary">{{item.text}}</span></v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>
